export const SET_USER = 'user:set';
export const SET_IMAGE_SRC = 'user:set-image-src';
export const CLEAR_USER = 'user:clear';
export const SET_SOCIAL_SECURITY_NUMBER = 'user:set-social-security-number';



/** WEBPACK FOOTER **
 ** ./src/redux/modules/user/action-types.js
 **/